import { OffCuffTabType } from '../states/renditionStates';
import services from '../services/axios-services';
import servicesConfig, { IServiceConfig } from '../services/servicesConfig';
import { Dispatch } from 'redux';
export interface IoffCuffListStateAction {
  type: string;
  value: any;
  tabType?: OffCuffTabType;
  reset?: boolean;
}
export const expandOffCuffId = (ids: Array<string>) => ({
  type: "EXPAND_OFFCUFF_ID",
  value: ids,
});
export const changeMode = (mode: OffCuffTabType) => ({
  type: "CHANGE_CURRENT_TAB_MODE",
  value: mode
});

export const requestOffCuffListData = () => ({
    type: "REQUEST_OFFCUFFLIST_DATA",
});

export const receiveOffCuffListData = (data: any, type: OffCuffTabType) => ({
    type: "RECEIVE_OFFCUFFLIST_DATA",
    value: data,
    tabType: type,
});

export const receiveByAuthorTopics = (data: any) => ({
    type: "RECEIVE_BYAUTHOR_TOPICS",
    value: data,
});
export const receiveByAllAuthors = (data: any) => ({
    type: "RECEIVE_BYALLAUTHORS",
    value: data,
});

export const receiveOffCuffCopyUrlData = (data: any) => ({
  type: "RECEIVE_OFFCUFF_COPY_URL_DATA",
  value: data,
});

export const fetchOffCuffPublicationLibrarys = (urlDetail: IServiceConfig, data: any, type: OffCuffTabType) => (dispatch: Dispatch) => {
    dispatch(requestOffCuffListData());
    const urlParams = ["periodicalId=" + data.periodicalId, 'language=' + data.language, 't=' + new Date().getTime()];
    if (data.analystId){
        urlParams.push("analystId=" + data.analystId);
    }
    urlDetail.url_parameter = urlParams;
    return services.getData(urlDetail, {}, '')
       .then((response: any) => {
        dispatch(receiveOffCuffListData(response.data, type));
        return response.data;
      })
      .catch((error: any) => {
        console.error(error); throw error;
      });
};
export const fetchSingleAuthorTopics = (analystId: string, periodicalid?: string) => (dispatch: Dispatch) => {
    const urlParams = ["analystid=" + analystId, "excludedperiodicalid=" + periodicalid, 't=' + new Date().getTime()];
    servicesConfig.GET_SINGLE_AUTHOR_TOPICS.url_parameter = urlParams;
    return services.getData(servicesConfig.GET_SINGLE_AUTHOR_TOPICS, {}, '')
    .then((response: any) => {
     dispatch(receiveByAuthorTopics(response.data));
     return response.data;
   })
   .catch((error: any) => {
     console.error(error); throw error;
   });
};

export const fetchAllAuthorInfo = (periodicalid: string) => (dispatch: Dispatch) => {
  const urlParams = ["periodicalid=" + periodicalid, 't=' + new Date().getTime()];
  servicesConfig.GET_ALL_AUTHORS_TOPICS.url_parameter = urlParams;
  return services.getData(servicesConfig.GET_ALL_AUTHORS_TOPICS, {}, '')
  .then((response: any) => {
   dispatch(receiveByAllAuthors(response.data));
   return response.data;
 })
 .catch((error: any) => {
   console.error(error); throw error;
 });
};
